import axios, { AxiosError } from 'axios';

export type EntitlementLimitCode =
  | 'PUZZLE_LIMIT'
  | 'SRS_REVIEW_LIMIT'
  | 'REPLAY_NEW_GAME_LIMIT'
  | 'REPLAY_HISTORY_LIMIT';

export type EntitlementErrorPayload = {
  message: string;
  code: EntitlementLimitCode;
  limit?: number;
  used?: number;
  availableAt?: string;
};

export const isEntitlementError = (
  error: unknown,
): error is AxiosError<EntitlementErrorPayload> => {
  if (!axios.isAxiosError(error) || error.response?.status !== 429) {
    return false;
  }
  const data = error.response.data;
  return (
    data != null &&
    typeof data === 'object' &&
    typeof data.code === 'string' &&
    typeof data.message === 'string'
  );
};

export const getEntitlementErrorMessage = (error: unknown): string | null => {
  if (!isEntitlementError(error)) {
    return null;
  }
  return error.response?.data.message ?? null;
};

export const formatEntitlementAvailableAt = (
  isoDate: string | undefined,
): string | null => {
  if (!isoDate) {
    return null;
  }
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(date);
};
